export default function Invoice({ className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      className={className}>
      <path d="M47 7.6H3c-1.7 0-3 1.3-3 3v28.8c0 1.7 1.3 3 3 3h44c1.7 0 3-1.3 3-3V10.6c0-1.7-1.3-3-3-3zM19.4 27.1L2 39.3V11.8l17.4 15.3zm1.6 1.4l2.2 1.9c.5.4 1.2.6 1.8.6.7 0 1.3-.2 1.9-.7l2.1-1.9 17.2 11.9H3.9L21 28.5zm26.9 10.7l-17.3-12L48 11.7l-.1 27.5c.1 0 .1 0 0 0zM47 9.6c.1 0 .2 0 .3.1L25.6 28.8c-.4.3-.9.3-1.2.1L2.6 9.7c.1 0 .2-.1.4-.1h44z" />
    </svg>
  )
}
